import type { SubscriptionPriceInfo } from '@ps/models/lib/creator-subscription';

export interface LongerCommitment {
  /** Number of months committed up front (e.g. 12). */
  months: number;
  /** Discount applied to the per-period price (e.g. 20 for 20% off). */
  discountPercentage: number;
}

/**
 * The longer-commitment terms a plan offers, or `null` when it doesn't. Upstream
 * (PopshopRN) gates the term toggle on all three fields agreeing: the discount
 * flag is on, the commitment period is a real multi-month span (> 1), and the
 * discount percentage is positive.
 */
export function longerCommitment(
  price: SubscriptionPriceInfo,
): LongerCommitment | null {
  const months = price.creator_sub_discount_commitment_period;
  const discountPercentage = price.creator_sub_commitment_discount_percentage;

  if (
    price.discount_for_longer_subscription_commitment === true &&
    months != null &&
    months > 1 &&
    discountPercentage != null &&
    discountPercentage > 0
  ) {
    return { months, discountPercentage };
  }
  return null;
}

/**
 * Total price for the full longer-commitment term, in the same units as
 * `perPeriod`: `perPeriod * (1 - discount%) * months`
 * (e.g. 19.99 monthly, 20% off, 12 months → 191.90).
 */
export function longCommitmentTotal(
  perPeriod: number,
  term: LongerCommitment,
): number {
  return perPeriod * (1 - term.discountPercentage / 100) * term.months;
}
